import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaFilePdf, FaFileInvoiceDollar } from 'react-icons/fa';
import useCargarCertificadoPagado from '../../hooks/useCargarCertificadoPagado';

/** Ruta de la página del certificado de renta pagada de un año+régimen. */
export const rutaCertificado = (anioTributario, regimen) =>
  `/declaracion-renta/certificado-pagado/${anioTributario}/${regimen}`;

/**
 * Botón único del certificado de renta pagada, con dos caras según si la
 * empresa ya cargó uno:
 *
 *   sin certificado  →  "Cargar PDF Renta Pagada"  (elige archivo y lo sube)
 *   con certificado  →  "Ver certificado renta pagada"  (abre su página)
 *
 * Vive en un solo lugar porque aparece en dos pantallas distintas: el
 * formulario (F22FormPage, antes de calcular) y la vista de la renta ya
 * calculada (RentaSavedView). Que esté también en el formulario es lo que
 * permite a una empresa que parte en el año X registrar su certificado sin
 * haber calculado nada — su balance de arrastre entra por asientos manuales.
 */
const CertificadoPagadoButton = ({ anioTributario, regimen, pagado, onCargado }) => {
  const navigate = useNavigate();
  const irAlCertificado = () => navigate(rutaCertificado(anioTributario, regimen));

  // Recién cargado, lo útil es ver qué se extrajo: se abre su página.
  const { cargando, seleccionarArchivo, inputProps } = useCargarCertificadoPagado(
    anioTributario,
    regimen,
    async () => {
      if (onCargado) await onCargado();
      irAlCertificado();
    }
  );

  if (pagado) {
    return (
      <button className="renta-saved-btn renta-saved-btn-secondary" onClick={irAlCertificado}>
        <FaFileInvoiceDollar /> Ver certificado renta pagada
      </button>
    );
  }

  return (
    <>
      <button
        className="renta-saved-btn renta-saved-btn-secondary"
        onClick={seleccionarArchivo}
        disabled={cargando}
      >
        <FaFilePdf /> {cargando ? 'Procesando...' : 'Cargar PDF Renta Pagada'}
      </button>
      <input {...inputProps} />
    </>
  );
};

export default CertificadoPagadoButton;
